import { __assign, __rest } from "tslib";
import PropTypes from 'prop-types';
import React from 'react';
import { Child, Ratio } from './styles';
import { convertRatioToNumber } from './utils';
export default function AspectRatio(_a) {
    var ratio = _a.ratio, children = _a.children, props = __rest(_a, ["ratio", "children"]);
    var numericRatio = convertRatioToNumber(ratio);
    var paddingTop = numericRatio === 0 ? '100%' : "".concat(100 / numericRatio, "%");
    return (React.createElement(Ratio, __assign({ pt: paddingTop }, props),
        React.createElement(Child, null, children)));
}
AspectRatio.propTypes = {
    children: PropTypes.node,
    ratio: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
AspectRatio.defaultProps = {
    ratio: 4 / 3,
};
